import { tooltip } from './_base';

const Food = () => {
  let value = 0;

  return {
    value,
    label: 'Food',
    isCarried: true,
    tooltip: gameState => tooltip('food', gameState),
    min: 0
  };
};

export default Food;
